export * from './collapsible.model';
